/**
 * AI Platform
 * Chat API of the hosted agent server (`@convercus/agent-server`). Read a chat as a view: a snapshot from `GET /chats/{chatId}/view`, then its changes from the NDJSON stream `GET /chats/{chatId}/view/stream?after` or the long-poll `GET /chats/{chatId}/view?after&waitMs`. The service sits behind the API gateway, which validates the JWT and forwards identity as plain headers — `program`, `user-id`, `username` and the user\'s `roles`. The view stream is the exception: it is reached without the gateway and verifies the `Authorization: Bearer` token itself. With `AUTH_MODE=mock` (local dev) every request runs as a canned identity and the headers are ignored. Every route but health names the permission it needs and answers 403 to a role that grants none of them: `agent.bi` (ANALYTICS, SUPER_ADMIN) for agents and chats; `agent.config.read`/`agent.config.write` (PROGRAM_MANAGER, SUPER_ADMIN) for the settings; dedicated mode and the spend ledger are SUPER_ADMIN only.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AgentCommand { 
    /**
     * Command name, surfaced to the user as `/name`.
     */
    name: string;
    /**
     * Command source; skills are the only kind today.
     */
    kind: AgentCommand.KindEnum;
    description?: string;
    /**
     * Pack domain this command belongs to. Send it with `route` as a message `hint` to invoke the command without putting a slash in the user\'s text. Absent when the skill declares no pack metadata.
     */
    domain?: string;
    /**
     * End-state route this command serves, within `domain`. Always present: since DEV-441 a command *is* a route, and `name` is that route — the two are the same string. Send it with `domain` as a message `hint`.
     */
    route: string;
}
export namespace AgentCommand {
    export type KindEnum = 'skill';
    export const KindEnum = {
        Skill: 'skill' as KindEnum
    };
}


